"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const CommonTokenStream_1 = require("antlr4ts/CommonTokenStream");
const CharStreams_1 = require("antlr4ts/CharStreams");
const AlgebrainLexer_1 = require("./parser/AlgebrainLexer");
const AlgebrainParser_1 = require("./parser/AlgebrainParser");
const Visitor_1 = require("./Visitor");
class Algebrain {
    static retrieveTree(text) {
        const inputStream = CharStreams_1.CharStreams.fromString(text);
        const lexer = new AlgebrainLexer_1.AlgebrainLexer(inputStream);
        const tokenStream = new CommonTokenStream_1.CommonTokenStream(lexer);
        const parser = new AlgebrainParser_1.AlgebrainParser(tokenStream);
        return parser.stat();
    }
    static parse(text) {
        const tree = Algebrain.retrieveTree(text);
        return new Visitor_1.default().visit(tree);
    }
    static multiParse(text) {
        return immutable_1.List(text.split('\n')).map(line => Algebrain.parse(line));
    }
}
exports.default = Algebrain;
//# sourceMappingURL=Algebrain.js.map